import firebase from "firebase";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { ChatMessage, ChatRequest, ChatRequestStatus, User } from "../../../interfaces";
import { usePrevious } from "../../../helpers/hooks/usePrevious";
//import RequestButton from "../../pages/Dashboard/Contents/HostManager/RequestButton";
import { TypedUseSelectorHook } from "../../../reducers";
import { setChatData } from "../../../actions/chatActions";
import getMilliseconds from "../../../helpers/objectManipulation/getMilliseconds";
import { CHAT_UNMOUNT, clearOldSnapshot, emit, initChat, Message, resubscribeToMessageHandler } from "./Chat.service";
import ChatConversation from "./ChatConversation";
import ChatInput from "./ChatInput";
import ChatLogin from "./ChatLogin";
import ProcessedChatConversation from "./ProcessedChatConversation";
import { style } from "./styles";
import PublicUser from "../../../interfaces/PublicUser";

interface ChatProps {
	id: string;
	isModerator: boolean;
	enableAnonymous: boolean;
	clientId: string;
	onMessages?: (chatId: string, messages: Message[]) => void;
	isDirect?: boolean;
	contentId: string;
	chatClosed?: boolean;
	isLightBackground?: boolean;
	isLoggingOut?: boolean;
	startChat?: (request: ChatRequest) => void;
	request?: ChatRequest;
	isHostManager?: boolean;
	
	canUseChatProcessor?: boolean;
	useChatProcessor?: boolean;
	enablePreview?: boolean;
	chatBlacklist?: string[];
	//userStatus?: UserStatus;
	setCurrentChat?: (chatRequest: ChatRequest) => void;
	firebaseApp: firebase.app.App;
	experienceId: string;
	pageId: string;
	channelName: string;
}

const useTypedSelector: TypedUseSelectorHook = useSelector;

const unsubscribes = [];



const Chat: React.FC<ChatProps> = ({
	clientId,
	id,
	isModerator = true,
	enableAnonymous,
	onMessages,
	isDirect = false,
	chatClosed = false,
	contentId,
	isLightBackground,
	isLoggingOut = false,
	startChat,
	request,
	isHostManager = true,
	
	useChatProcessor = false,
	canUseChatProcessor = false,
	enablePreview = false,
	chatBlacklist,
	//userStatus,
	setCurrentChat,
	firebaseApp,
	experienceId,
	pageId,
	channelName,
}) => {
	const { search } = useLocation();
	const searchParams = new URLSearchParams(search.replace("?", ""));
	// const videoId = searchParams.get("videoId");

	const db = firebaseApp.firestore();
	const auth = firebaseApp.auth();

	console.log(experienceId,
		pageId,
		channelName)

	const [isReady, setIsReady] = useState(false);
	const [userName, setUserName] = useState(auth.currentUser ? auth.currentUser?.displayName : null);
	const [uid, setUid] = useState(auth.currentUser ? auth.currentUser?.uid : undefined);

	const [email, setEmail] = useState(auth.currentUser ? auth.currentUser?.email : null);
	const [bannedUsers, setBannedUsers] = useState<string[]>([]);
	const [inputHeight, setInputHeight] = useState(24);
	const [hasPinnedChats, setHasPinnedChat] = useState(false);
	const [showTranferOptions, setShowTransferOptions] = useState(false);
	const [loadingUsers, setLoadingUsers] = useState(false);
	const [userList, setUserList] = useState<User[]>([]);
	const [selectedUser, setSelectedUser] = useState<User>();

	const [publicUserList, setPublicUserList] = useState<PublicUser[]>();

	const dispatch = useDispatch();

	const onLogin = (loginDetail: any) => {
		// check who'd logged in
		setUid(loginDetail.userName.uid);
		setUserName(loginDetail.userName.displayName);
		setEmail(loginDetail.email);
	};
	const user = firebaseApp.auth().currentUser as firebase.User;
	const chat = useTypedSelector(store => store.chat);

	console.log(user);

	const {photoURL} = user;
	console.log("photoURL", photoURL);

	const oldId = usePrevious(id) as any;

	const acceptChat = () => {
		if (contentId) {
			const docRef = db
				.collection("chat")
				.doc("direct")
				.collection(contentId)
				.doc(id);
			docRef.get().then(doc => {
				const request = doc.data() as ChatRequest;
				if (request.status === ChatRequestStatus.request) {
					request.status = ChatRequestStatus.active;
				} else if (request.status === ChatRequestStatus.directMessageRequest) {
					request.status = ChatRequestStatus.directMessageActive;
				}
				docRef.set(request);
			});
		}
	};

	const endChat = () => {
		if (contentId && uid) {
			const docRef = db
				.collection("chat")
				.doc("direct")
				.collection(contentId)
				.doc(id);
			docRef.get().then(doc => {
				const request = doc.data() as ChatRequest;
				if (
					request.userData[uid].status === ChatRequestStatus.request ||
					request.userData[uid].status === ChatRequestStatus.active
				) {
					request.userData[uid].status = ChatRequestStatus.ended;
					if (Object.values(request.userData).every(x => ChatRequestStatus.ended === x.status)) {
						request.status = ChatRequestStatus.ended;
					}
				} else if (
					request.userData[uid].status === ChatRequestStatus.directMessageActive ||
					request.userData[uid].status === ChatRequestStatus.directMessageRequest
				) {
					request.userData[uid].status = ChatRequestStatus.directMessageEnded;
					if (Object.values(request.userData).every(x => ChatRequestStatus.directMessageEnded === x.status)) {
						request.status = ChatRequestStatus.directMessageEnded;
					}
				}

				docRef.set(request);
			});
		}
	};

	const blockChat = () => {
		if (contentId) {
			const docRef = db
				.collection("chat")
				.doc("direct")
				.collection(contentId)
				.doc(id);
			docRef.get().then(doc => {
				const request = doc.data() as ChatRequest;
				request.status = ChatRequestStatus.blocked;
				Object.values(request.userData).forEach(d => {
					d.status = ChatRequestStatus.blocked;
				});
				docRef.set(request);
			});
		}
	};

	const handleNewMessageCount = (messages: Message[]) => {
		if (onMessages) {
			onMessages(id, messages);
		}
	};

	const getBannedUsers = () => {
		if (id) {
			let bannedUsersArr: string[] = [];
			const docRef = db
				.collection("chat")
				.doc("banned")
				.collection(id);

			docRef.get().then(querySnapshot => {
				querySnapshot.forEach(doc => {
					bannedUsersArr.push(doc.id);
				});
			});
			setBannedUsers(bannedUsersArr);
		}
	};

	const getPublicUsers = () => {
		db
				.collection("public-users")
				.get()
				.then(docs => {
					const publicUserList: PublicUser[] = [];
					docs.forEach(doc => {
						publicUserList.push(doc.data() as PublicUser);
					});
					setPublicUserList(publicUserList);
				})
				.catch(e => {
					console.log(e);
				});
	};

	const getPreprocessedChats = (since?: firebase.firestore.Timestamp) => {
		let query = db
			.collection("chat")
			.doc("processed-contents")
			.collection(id)
			.orderBy(since ? "updatedAt" : "timestamp", "desc")
			.limit(since ? 500 : 100);
		if (since) {
			query = query.where("updatedAt", ">=", since);
		}
		query.get().then(messageDocs => {
			const messages: { [key: string]: ChatMessage } = {};
			let latestMessage: firebase.firestore.Timestamp | undefined = undefined;
			messageDocs.forEach(message => {
				const md = message.data() as ChatMessage;
				md.id = message.id;
				if (latestMessage === undefined || latestMessage.toMillis() < md.updatedAt.toMillis()) {
					latestMessage = md.updatedAt;
				}
				messages[message.id] = md;
			});

			db.collection("chat")
				.doc("processed-contents")
				.collection(id)
				.where("isPinned", "==", true)
				.get()
				.then(pinnedChats => {
					pinnedChats.forEach(pinnedChat => {
						const md = pinnedChat.data() as ChatMessage;
						messages[pinnedChat.id] = md;
					});
				});

			dispatch(
				setChatData({
					messages,
					chatId: id,
					latestMessage,
					removeOldMessages: false,
				})
			);
		});
	};

	useEffect(() => {
		if (oldId) {
			clearOldSnapshot(oldId);
		}
		initChat(id, handleNewMessageCount, dispatch, firebaseApp);
		if (chat.chatId !== id && useChatProcessor) {
			//get the prexisting chats
			getPreprocessedChats();
		} else if (useChatProcessor) {
			//get the change since the last time you were here
			getPreprocessedChats(
				chat.latestMessage
					? firebase.firestore.Timestamp.fromMillis(getMilliseconds(chat.latestMessage as unknown as firebase.firestore.Timestamp))
					: undefined
			);
		}
		setIsReady(true);
		const unsubscribe = db
			.collection("chat")
			.doc("banned")
			.collection(id)
			.onSnapshot(docs => {
				const bannedUsers: string[] = [];
				docs.forEach(doc => {
					bannedUsers.push(doc.id);
				});
				setBannedUsers(bannedUsers);
			});

		return () => {
			unsubscribe();
			emit(CHAT_UNMOUNT, { chatId: id }, id);
		};
	}, [id]);

	useEffect(() => {
		setIsReady(false);
		getBannedUsers();
		getPublicUsers();
		setTimeout(() => {
			initChat(id, handleNewMessageCount, dispatch, firebaseApp);
			setIsReady(true);
		}, 1);
		return () => {
			emit(CHAT_UNMOUNT, { chatId: id }, id);
		};
	}, [id]);

	useEffect(() => {
		resubscribeToMessageHandler(id, handleNewMessageCount);
	}, [onMessages]);

	useEffect(() => {
		if (showTranferOptions) {
			//setLoadingUsers(true);
			//getUsers();
		}
	}, [showTranferOptions]);

	useEffect(() => {
		if (auth.currentUser) {
			setUid(auth.currentUser.uid);
			
			setUserName(auth.currentUser.displayName);
			setEmail(auth.currentUser.email);
		} else {
			setUid(undefined);
			setUserName(null);
			setEmail(null);
		}
	}, [auth.currentUser?.uid, auth.currentUser?.displayName]);

	// const swapHost = (user: User) => {
	// 	if (uid) {
	// 		const docRef = db
	// 			.collection("chat")
	// 			.doc("direct")
	// 			.collection(contentId)
	// 			.doc(id);

	// 		docRef.get().then(doc => {
	// 			const data = doc.data() as ChatRequest;
	// 			if (data.userData) {
	// 				data.userData[user.publicId] = {
	// 					name: `${user.firstName} ${user.lastName}`,
	// 					muted: false,
	// 					image: auth.currentUser?.photoURL ?? "",
	// 					status: data.userData[uid].status,
	// 				};
	// 				delete data.userData[uid];
	// 			}
	// 			data.hosts = [user.publicId];
	// 			data.users = data.users.filter(u => u !== uid);
	// 			data.users.push(user.publicId);
	// 			if (data.createdBy === uid) {
	// 				docRef.set(
	// 					Object.assign({}, data, {
	// 						userName: `${user.firstName} ${user.lastName}`,
	// 						createdBy: user.publicId,
	// 					})
	// 				);
	// 			} else {
	// 				docRef
	// 					.set(Object.assign({}, data, { recipientUserName: `${user.firstName} ${user.lastName}` }))
	// 					.catch(err => {});
	// 			}
	// 			const newMessage = {
	// 				userName,
	// 				uid,
	// 				message: `***** ${renderUserName(userName, user)} has transferred this chat to ${
	// 					user.firstName
	// 				} ${user.lastName} *****`,
	// 				timestamp: firebase.firestore.FieldValue.serverTimestamp(),
	// 				updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
	// 				photoURL: photoURL ? `https://media.online.brushfire.com/profile_images/${uid}/profile.jpg` : null,
	// 				isHost: true,
	// 				flags: [],
	// 				isDeleted: false,
	// 			};
	// 			db.collection("chat")
	// 				.doc("contents")
	// 				.collection(id)
	// 				.add(newMessage);
	// 		});
	// 	}
	// };

	// useEffect(() => {
	// 	unsubscribes.push(setupConvoListener({ id, onReadConvo: onNewConvoEvent, deleteMessage }));
	// 	// componentWillUnmount
	// 	return () => {
	// 	  flushConvo();
	// 	  unsubscribes.map((u) => u());
	// 	};
	//   }, [chatId]);

	const renderUserName = (userName: string | null, appUser: firebase.User) => {
		if (appUser && appUser.displayName) {
			return appUser.displayName;
		} else if (userName) {
			return userName;
		} else {
			return "Anonymous User";
		}
	};

	if (!isReady) {
		return null;
	}

	if (isLoggingOut) {
		return (
			<style.ChatWrapper>
				<div className="absolute-center ta-center">
					<i className="fal fa-spinner-third fa-spin fa-2x m-bottom"></i>
					<br />
					Logging Out
				</div>
			</style.ChatWrapper>
		);
	}

	const showLoginButton = enablePreview && !user?.displayName;

	if(!user){
		return null;
	}

	
		return (
			<style.ChatWrapper className={`${hasPinnedChats ? "has-pinned-chats" : ""}`}>
				{/* {isHostManager && (
					<div className={`host-transfer-overlay ${showTranferOptions ? "active" : ""}`}>
						<div
							className={`cancel`}
							onClick={() => {
								setShowTransferOptions(false);
							}}
						>
							<i className="fal fa-times"></i>
						</div>
						<div className="host-transfer-options">
							{userList.map(user => {
								if (user.publicId && user.publicId !== uid) {
									return (
										<RequestButton
											uid={user.firebaseId}
											key={user.id}
											onClick={() => setSelectedUser(user)}
											title={`${user.firstName} ${user.lastName}`}
											contentId={contentId}
											active={selectedUser?.id === user.id}
										/>
									);
								}
							})}
							<div
								className={`btn btn-primary btn-block btn-sm m-top ${selectedUser ? "" : "disabled"}`}
								onClick={() => {
									if (selectedUser) {
										swapHost(selectedUser);
									}
								}}
							>
								Transfer
							</div>
						</div>
					</div>
				)} */}
				{useChatProcessor ? (
					<ProcessedChatConversation
						chatId={id}
						clientId={clientId}
						isModerator={isModerator}
						uid={uid ?? ""}
						isDirect={isDirect}
						bannedUsers={bannedUsers}
						isLightBackground={isLightBackground || false}
						isHostManager={isHostManager || false}
						chatClosed={chatClosed}
						useChatProcessor={useChatProcessor}
						inputHeight={showLoginButton ? 11 : inputHeight}
						userLoggedIn
						userName={renderUserName(userName, user)}
						photoURL={photoURL}
						chatBlacklist={chatBlacklist}
						setHasPinnedChat={setHasPinnedChat}
						enableDirectMessaging={false}
						setCurrentChat={setCurrentChat}
						firebaseApp={firebaseApp}
					/>
				) : (
					<>
						{canUseChatProcessor && <style.OldChatCorner isLightBackground={isLightBackground} />}
						<ChatConversation
							chatId={id}
							clientId={clientId}
							isModerator={isModerator}
							uid={uid}
							videoId={id}
							isDirect={isDirect}
							request={request}
							bannedUsers={bannedUsers}
							isLightBackground={isLightBackground}
							isHostManager={isHostManager}
							chatClosed={chatClosed}
							useChatProcessor={useChatProcessor}
							inputHeight={showLoginButton ? 11 : inputHeight}
							userLoggedIn
							photoURL={photoURL}
							acceptChat={acceptChat}
							endChat={endChat}
							blockChat={blockChat}
							user={auth.currentUser}
							contentId={contentId}
							setHasPinnedChat={setHasPinnedChat}
							setShowTransferOptions={setShowTransferOptions}
							//enableDirectMessaging={content.chat.enableDirectMessaging}
						/>
					</>
				)}

				<ChatInput
					chatId={id}
					isModerator={isModerator}
					userName={renderUserName(userName, user)}
					email={email}
					uid={uid}
					photoURL={photoURL}
					videoId={id}
					user={auth.currentUser}
					isDirect={isDirect}
					endChat={endChat}
					bannedUsers={bannedUsers}
					startChat={startChat}
					request={request}
					isHostManager={isHostManager}
					useChatProcessor={useChatProcessor}
					inputHeight={inputHeight}
					setInputHeight={setInputHeight}
					enablePreview
					dispatch={dispatch}
					contentId={contentId}
					experienceId={experienceId}
					pageId={pageId}
					channelName={channelName}
					publicUserList={publicUserList}
					//userStatus={userStatus}
				/>
			</style.ChatWrapper>
		);
	
};

export default Chat;
